import { escapeHtml, glyph } from "../lib/util.js";
import { state } from "../lib/state.js";
import { navigate } from "../lib/router.js";
import { addToCart } from "../lib/cart.js";

function chip(item, qty) {
  if (!item) return "";
  const qtyHtml = qty != null ? `<span class="chip-qty">${escapeHtml(qty)}×</span>` : "";
  return `
    <button type="button" class="chip" data-slug="${escapeHtml(item.slug)}">
      ${glyph(item.name, item.colour)}
      ${qtyHtml}
      <span>${escapeHtml(item.name)}</span>
    </button>`;
}

function renderRecipe(recipe, outputItem) {
  const inputs = (recipe.inputs || []).map((inp) => chip(inp.item, inp.qty)).join("");
  const output = outputItem
    ? chip(outputItem, recipe.outputQty)
    : `<span class="chip"><span class="chip-qty">${escapeHtml(recipe.outputQty ?? 1)}×</span><span>output</span></span>`;
  return `
    <div class="recipe">
      <span class="recipe-kind">${escapeHtml(recipe.operation || recipe.kind || "craft")}</span>
      <div class="recipe-flow">
        ${inputs || `<span class="empty">No inputs listed</span>`}
        <span class="arrow">→</span>
        ${output}
      </div>
    </div>`;
}

function renderUse(use) {
  const inputs = (use.inputs || []).map((inp) => chip(inp.item, inp.qty)).join("");
  return `
    <div class="recipe">
      <span class="recipe-kind">${escapeHtml(use.operation || use.kind || "craft")}</span>
      <div class="recipe-flow">
        ${inputs}
        <span class="arrow">→</span>
        ${chip(use.output, use.outputQty)}
      </div>
    </div>`;
}

export function renderItem(els, slug) {
  const detail = state.details?.[slug];
  if (!detail) {
    els.itemPanel.innerHTML = `<p class="empty">Item not found.</p>`;
    return detail;
  }

  const recipes = detail.recipes || [];
  const uses = detail.uses || [];

  els.itemPanel.innerHTML = `
    <div class="item-hero">
      ${glyph(detail.name, detail.colour)}
      <div>
        <h2 class="item-name">${escapeHtml(detail.name)}</h2>
        <p class="item-meta">${escapeHtml([detail.group, detail.catalogue].filter(Boolean).join(" · "))}</p>
      </div>
    </div>
    <p class="item-desc">${escapeHtml(detail.description || "No description available.")}</p>
    <div class="action-row">
      <button type="button" class="btn primary" data-add-cart="${escapeHtml(detail.slug)}" data-name="${escapeHtml(detail.name)}">
        Add to cart
      </button>
    </div>
    <section class="section">
      <h3 class="section-title">How to make</h3>
      ${
        recipes.length
          ? recipes.map((r) => renderRecipe(r, detail)).join("")
          : `<p class="empty">No crafting recipes produce this item (raw material or drop).</p>`
      }
    </section>
    <section class="section">
      <h3 class="section-title">Used to make</h3>
      ${
        uses.length
          ? uses.map(renderUse).join("")
          : `<p class="empty">Not used as an ingredient in known recipes.</p>`
      }
    </section>
  `;
  return detail;
}

export function bindItem(els) {
  els.itemPanel.addEventListener("click", (e) => {
    const add = e.target.closest("[data-add-cart]");
    if (add) {
      addToCart(add.dataset.addCart, 1, add.dataset.name);
      const btn = add;
      btn.textContent = "Added ✓";
      setTimeout(() => {
        btn.textContent = "Add to cart";
      }, 900);
      return;
    }
    const chipBtn = e.target.closest("[data-slug]");
    if (chipBtn) navigate("item", chipBtn.dataset.slug);
  });
}
